export const addProductMixin = {
  data(){
    return{
      checkedMealTimeBoxState:false,
      resourceObj:null,
      productObj:null,
      chenckBudgteObj:null,
      keyStr:null,
    }
  },
  methods:{
    closeDialog(){
      this.checkedMealTimeBoxState = false
      this.$emit("closeDialog");
    },
    beforeOpenDialog(item,item2,chenckBudgteObj,keyStr){
      this.checkedMealTimeBoxState = true
      this.resourceObj = item
      this.productObj=item2
      this.chenckBudgteObj = chenckBudgteObj
      this.keyStr = keyStr
      this.$nextTick(()=>{
        this.$refs.addProductDialog.clearData()
        this.$refs.addProductDialog.$refs.addLinkProduct.getDataList([item2.stockId])
      })
    }
  }
}